export default "__VITE_ASSET__9b898e38__"